import { Table as BaseTable, ContextMenu, PhotoRenderer } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
`;

const Container = styled.div``;

const Table = styled(BaseTable)`
  margin-top: 10px;
`;

const ActionsRenderer = ({ rowData, columnData: { onEdit, onDelete } }) => {
  const { t } = useContext(ConfigContext);
  const options = useMemo(
    () => [
      { label: t('edit'), onClick: () => onEdit(rowData) },
      {
        label: t('delete'),
        onClick: () => onDelete(rowData.id),
        visible: !!rowData?.id && onDelete,
        confirm: true,
        confirmBody: t('areYouSureYouWantToDelete'),
        confirmText: 'delete',
        confirmPortal: true
      }
    ],
    [onDelete, onEdit, rowData, t]
  );

  return <ContextMenu options={options} usePortal />;
};

const LocationAreasTable = ({ t, data, onEdit, onDelete }) => {
  const columns = [
    {
      Header: t('photo'),
      dataKey: 'photo',
      Cell: ({ rowData }) => <PhotoRenderer rowData={{ image: rowData.photo || rowData.image }} />,
      width: 50
    },
    {
      Header: t('areaName'),
      dataKey: 'name',
      Cell: ({ rowData: { name } }) => {
        return <Wrapper>{name}</Wrapper>;
      }
    },
    {
      Header: t('address'),
      dataKey: 'address',
      Cell: ({ rowData: { address } }) => {
        return <Wrapper>{address}</Wrapper>;
      }
    }
  ];

  return (
    <Container>
      <Table
        headerRowHeight={50}
        isLoading={false}
        autoHeight
        data={data}
        columns={columns}
        shadow={false}
        actionRenderer={({ rowData }) => <ActionsRenderer rowData={rowData} columnData={{ onDelete, onEdit }} />}
      />
    </Container>
  );
};

export default LocationAreasTable;
